export default __webpack_public_path__ + "static/media/pt-girl.56be458d.webp";